import React from "react";
import "./footer.scss";

const currentYear = new Date().getFullYear().toString()

export default function footer() {
	return (
		<div className="footer-container">
			<div className=" container">
				<div className="w-75 mx-auto">
					<p>
						Medi-Weightloss© 2016-{currentYear} Medi IP, LLC, All rights reserved • <a href="https://mediweightloss.com/terms-of-use/" rel="noopener noreferrer" target="_blank">Terms of Use Agreement
						</a> • <a href="https://mediweightloss.com/phi/" rel="noopener noreferrer" target="_blank">PHI</a> • <a href="https://mediweightloss.com/privacy-policy/" rel="noopener noreferrer" target="_blank">Privacy
						Policy</a> • <a href="https://mediweightloss.com/ada-notice/" rel="noopener noreferrer" target="_blank">Accessibility Notice
						</a> • <a href="https://www.surveygizmo.com/s3/5367889/SPW-BETA-Feedback" rel="noopener noreferrer" target="_blank">Feedback</a>
					</p>
					<p>
						Medi-Weightloss® is a program of weekly follow-up visits during the first phase of the program. Results
						may vary from patient to patient. Rapid weight loss may be associated with certain medical conditions
						and should only be considered by those who are medically appropriate.
					</p>
				</div>
			</div>
		</div>
	);
}
